// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__OcvkT","socials":"styles_socials__LN3bi","noInfo":"styles_noInfo__U0Cwk","title":"styles_title__1Bzo5","emptySocials":"styles_emptySocials__e-VXy"};